import { Api } from './api';

export class DrawsApi {
    private static readonly PATH = '/draws';

    constructor(private readonly m_api: Api) {}

    public async getDraws() {
        return this.m_api.get(DrawsApi.PATH);
    }

    public async getWinners(page: number) {
        return this.m_api.get(`${DrawsApi.PATH}/winners?page=${page}`);
    }

    public async buyDrawTicket(drawId: number, amount: number) {
        return this.m_api.post(`${DrawsApi.PATH}/buy-ticket`, { drawId, amount });
    }
    
    public async confirmDrawWin(drawId: number) {
        return this.m_api.post(`${DrawsApi.PATH}/confirm-win`, { drawId });
    }
}